<div class="comment-component-wrapper">
  <!-- User metadata header & comment actions -->
  <div class="comment-metadata-avatar-col">
    <img
      matListAvatar
      src="{{ comment.metadata?.user?.picture }}"
      onerror="this.src = '../../../../../../assets/dummy/dummy-logo.jpg'"
    />
  </div>
  <div class="comment-metadata-content-col">
    <div matLine class="comment-metadata-org">
      <span
        >{{ comment.metadata?.user?.organization || 'Guest Org' }}
        {{
          comment.metadata?.user?.job_title
            ? ' ・ ' + comment.metadata?.user?.job_title
            : ''
        }}</span
      >
      <div>{{ comment.timeSince }}</div>
    </div>
    <div matLine class="comment-metadata-and-actions">
      <div class="comment-metadata-name">
        {{ comment.metadata?.user?.name || 'Guest' }}
        <i *ngIf="comment.metadata?.isPublicComment">(Not logged-in user)</i>
      </div>
      <div class="comment-actions">
        <button
          *ngIf="user?.id === comment.owner_id"
          mat-icon-button
          color="primary"
          [disabled]="comment.edit_expanded"
          (click)="
            comment.edit_expanded = !comment.edit_expanded;
            comment.reply_expanded = false
          "
        >
          <mat-icon>edit</mat-icon>
        </button>
        <button
          *ngIf="
            user?.id === comment.owner_id ||
            userLoggedTopRole === 'org_admin' ||
            userLoggedTopRole === 'rf_backoffice'
          "
          mat-icon-button
          color="warn"
          (click)="triggerEvent('delete', null, comment.id, userLoggedTopRole)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
    <div
      *ngIf="comment.edit_expanded; else readComment"
      matLine
      class="comment-edit"
    >
      <app-comment-reply
        [accessMode]="accessMode"
        [inputComment]="comment.comment"
        (replied)="
          triggerEvent('update', $event, comment.id);
          comment.edit_expanded = false
        "
        (cancel)="comment.edit_expanded = false"
      ></app-comment-reply>
    </div>
    <ng-template #readComment>
      <div matLine class="comment-text">
        {{ comment.comment }}
        <span
          *ngIf="
            comment.updated_at && comment.created_at !== comment.updated_at
          "
          >(edited)</span
        >
      </div>
    </ng-template>
    <div
      class="comment-reply-actions"
      *ngIf="!(comment.reply_expanded && comment.children?.length < 1)"
    >
      <button
        mat-button
        class="comment-reply-button"
        color="primary"
        matLine
        [disabled]="comment.edit_expanded || comment.reply_expanded"
        (click)="triggerEvent('reply', $event, comment.id)"
      >
        REPLY
      </button>
      <ng-container *ngIf="comment.children?.length" matLine>
        ・
        <button
          mat-button
          *ngIf="!comment.children_expanded"
          class="comment-reply-button"
          color="primary"
          (click)="triggerEvent('expand', $event, comment.id)"
          matLine
        >
          <span> View {{ comment.children.length }} </span>
          <span *ngIf="comment.children.length < 2">reply</span>
          <span *ngIf="comment.children.length > 1">replies</span>
          <mat-icon>expand_more</mat-icon>
        </button>
        <button
          mat-button
          *ngIf="comment.children_expanded"
          class="comment-reply-button"
          color="primary"
          (click)="triggerEvent('expand', $event, comment.id)"
          matLine
        >
          <span> Hide {{ comment.children.length }} </span>
          <span *ngIf="comment.children.length < 2">reply</span>
          <span *ngIf="comment.children.length > 1">replies</span>
          <mat-icon>expand_less</mat-icon>
        </button>
      </ng-container>
    </div>
    <app-comment-reply
      *ngIf="comment.reply_expanded"
      [accessMode]="accessMode"
      (replied)="
        triggerEvent('post', $event, comment.id); comment.reply_expanded = false
      "
      (cancel)="triggerEvent('reply', $event, comment.id)"
    ></app-comment-reply>
    <ng-container *ngIf="comment.children_expanded" matLine>
      <ng-container *ngFor="let child of comment.children">
        <app-comment
          [accessMode]="accessMode"
          [comment]="child"
          [user]="user"
          [userLoggedTopRole]="userLoggedTopRole"
          (actionComment)="actionComment.emit($event)"
        ></app-comment>
      </ng-container>
    </ng-container>
  </div>
</div>
